import { Link } from 'react-router-dom';
import { Grid } from '@material-ui/core';
import withStyles from '@material-ui/styles/withStyles';

import logo from 'assets/choreograf_logo.svg';
import demologo from 'assets/well_integrity_logo.svg';
import clientConfig from 'infrastructure/config/index';
import { ENVIRONMENTS } from 'app/app.constants';
import config from 'infrastructure/config/index';

const Logo = ({ classes, rootUrl }) => {
  const logoUrl =
    config.environmentName === ENVIRONMENTS.DEM
      ? demologo
      : clientConfig.brandingAppLogoUrl || logo;

  return (
    <Grid
      component={rootUrl ? Link : undefined}
      to={rootUrl ? rootUrl : undefined}
    >
      <img
        src={logoUrl}
        alt="Choreograf Collaborate Logo"
        className={classes.logo}
      />
    </Grid>
  );
};

const styles = (theme) => ({
  logo: {
    display: 'flex',
    height: theme.spacing(3),
    paddingLeft: theme.spacing(1),
  },
});

export default withStyles(styles)(Logo);
